import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import GroupCreationForm from "../components/groups/GroupCreationForm";
import { apiService } from "../services/api";
import { GroupCreationFormData } from "../types";
import "./group-setup-page.css";

const GroupSetupPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentGroupSlug, isAuthenticated } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>("");

  // Redirect to dashboard if user is already authenticated with a group
  useEffect(() => {
    if (isAuthenticated && currentGroupSlug) {
      navigate(`/${currentGroupSlug}/dashboard`);
    }
  }, [isAuthenticated, currentGroupSlug, navigate]);

  // Remove main padding for this page
  useEffect(() => {
    document.body.classList.add("homepage-route");
    return () => {
      document.body.classList.remove("homepage-route");
    };
  }, []);

  // Set page title and meta description
  useEffect(() => {
    document.title = "Crea il tuo gruppo - CosaVorrei";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Crea un gruppo per organizzare i regali con famiglia, amici o colleghi. Inizia subito a gestire le liste regalo in modo semplice."
      );
    }
  }, []);

  const handleGroupCreation = async (formData: GroupCreationFormData) => {
    try {
      setIsLoading(true);
      setError("");

      const result = await apiService.createGroup(formData);

      // User is now automatically logged in via session
      // Redirect directly to the group dashboard
      globalThis.location.href = `/${result.group.slug}/dashboard`;
    } catch (error: any) {
      console.error("Group creation failed:", error);
      setError(
        error.response?.data?.message ??
          "Errore nella creazione del gruppo. Riprova."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="group-setup-page">
      <header className="group-setup-header">
        <nav className="group-setup-nav">
          <Link to="/" className="group-setup-logo">
            CosaVorrei
          </Link>
          <div className="group-setup-nav-buttons">
            <Link to="/login" className="group-nav-btn">
              Accedi
            </Link>
          </div>
        </nav>
      </header>

      <div className="group-setup-main">
        <GroupCreationForm
          onSubmit={handleGroupCreation}
          isLoading={isLoading}
          error={error}
        />
      </div>
    </div>
  );
};

export default GroupSetupPage;
